// Catálogo de plantillas UTILITY pre-validadas contra Meta Cloud API (feat_119, textos feat_121).
//
// Concepto: una plantilla se usa para INICIAR o reabrir la conversación (ventana de 24hs
// cerrada). Si el cliente ya escribió, la ventana está abierta y se usa texto libre, no
// plantilla. Por eso TODOS los textos arrancan la conversación desde el lado del negocio.
//
// Reglas que TODA plantilla respeta (validadas empíricamente en feat_118):
//   - example.body_text obligatorio (un valor por variable)
//   - variables {{n}} correlativas desde {{1}}  ({{1}}=nombre, {{2}}=empresa/fecha)
//   - la variable NUNCA va al inicio ni al final del texto
//   - contenido UTILITY transaccional (no outreach / no promoción)
//
// Los BODYS son DATOS (4 idiomas), no labels de UI → viven acá, no en i18n.
// Los nombres legibles SÍ son i18n: metaTemplates.suggested.names.<key>.

const SUGGESTED_TEMPLATES = [
  {
    key: "retomar_conversacion",
    category: "UTILITY",
    variableCount: 2,
    langs: {
      es: {
        body: "Hola {{1}}, te escribimos de {{2}}. Quedamos a tu disposición para continuar con tu consulta cuando gustes.",
        examples: ["Juan", "Mi Empresa"],
      },
      it: {
        body: "Ciao {{1}}, ti scriviamo da {{2}}. Restiamo a tua disposizione per continuare con la tua richiesta quando vuoi.",
        examples: ["Marco", "Mia Azienda"],
      },
      en: {
        body: "Hi {{1}}, we're reaching out from {{2}}. We're here to continue with your inquiry whenever you'd like.",
        examples: ["John", "My Company"],
      },
      pt: {
        body: "Olá {{1}}, escrevemos da {{2}}. Estamos à disposição para continuar com sua consulta quando quiser.",
        examples: ["João", "Minha Empresa"],
      },
    },
  },
  {
    key: "recordatorio_cita",
    category: "UTILITY",
    variableCount: 2,
    langs: {
      es: {
        body: "Hola {{1}}, te recordamos tu cita del {{2}}. Respondé este mensaje para confirmar o reprogramar.",
        examples: ["Juan", "15/06 a las 10hs"],
      },
      it: {
        body: "Ciao {{1}}, ti ricordiamo il tuo appuntamento del {{2}}. Rispondi a questo messaggio per confermare o riprogrammare.",
        examples: ["Marco", "15/06 alle 10:00"],
      },
      en: {
        body: "Hi {{1}}, this is a reminder of your appointment on {{2}}. Reply to this message to confirm or reschedule.",
        examples: ["John", "June 15 at 10am"],
      },
      pt: {
        body: "Olá {{1}}, lembramos da sua consulta do dia {{2}}. Responda esta mensagem para confirmar ou remarcar.",
        examples: ["João", "15/06 às 10h"],
      },
    },
  },
  {
    key: "seguimiento_general",
    category: "UTILITY",
    variableCount: 2,
    langs: {
      es: {
        body: "Hola {{1}}, queríamos hacer un seguimiento de tu consulta con {{2}}. ¿Seguimos avanzando?",
        examples: ["Juan", "Mi Empresa"],
      },
      it: {
        body: "Ciao {{1}}, volevamo dare un seguito alla tua richiesta con {{2}}. Andiamo avanti?",
        examples: ["Marco", "Mia Azienda"],
      },
      en: {
        body: "Hi {{1}}, we wanted to follow up on your inquiry with {{2}}. Shall we keep moving forward?",
        examples: ["John", "My Company"],
      },
      pt: {
        body: "Olá {{1}}, queríamos acompanhar sua consulta com {{2}}. Vamos seguir em frente?",
        examples: ["João", "Minha Empresa"],
      },
    },
  },
  {
    key: "aviso_disponible",
    category: "UTILITY",
    variableCount: 2,
    langs: {
      es: {
        body: "Hola {{1}}, te contactamos de {{2}} con novedades sobre tu consulta. Respondé este mensaje para que te demos los detalles.",
        examples: ["Juan", "Mi Empresa"],
      },
      it: {
        body: "Ciao {{1}}, ti contattiamo da {{2}} con novità sulla tua richiesta. Rispondi a questo messaggio e ti diamo i dettagli.",
        examples: ["Marco", "Mia Azienda"],
      },
      en: {
        body: "Hi {{1}}, we're contacting you from {{2}} with updates about your inquiry. Reply to this message and we'll share the details.",
        examples: ["John", "My Company"],
      },
      pt: {
        body: "Olá {{1}}, entramos em contato da {{2}} com novidades sobre sua consulta. Responda esta mensagem para darmos os detalhes.",
        examples: ["João", "Minha Empresa"],
      },
    },
  },
  {
    key: "reapertura_24h",
    category: "UTILITY",
    variableCount: 2,
    langs: {
      es: {
        body: "Hola {{1}}, pasó un tiempo desde tu último mensaje con {{2}}. Si seguís interesado, respondé y retomamos donde quedamos.",
        examples: ["Juan", "Mi Empresa"],
      },
      it: {
        body: "Ciao {{1}}, è passato un po' di tempo dal tuo ultimo messaggio con {{2}}. Se sei ancora interessato, rispondi e riprendiamo da dove eravamo.",
        examples: ["Marco", "Mia Azienda"],
      },
      en: {
        body: "Hi {{1}}, it's been a while since your last message with {{2}}. If you're still interested, reply and we'll pick up where we left off.",
        examples: ["John", "My Company"],
      },
      pt: {
        body: "Olá {{1}}, faz um tempo desde sua última mensagem com {{2}}. Se ainda tiver interesse, responda e retomamos de onde paramos.",
        examples: ["João", "Minha Empresa"],
      },
    },
  },
];

// Idiomas soportados por el catálogo; fallback es.
export const CATALOG_LANGS = ["es", "it", "en", "pt"];

// Normaliza el código de i18next ("es-AR" → "es") al idioma del catálogo.
export const resolveCatalogLang = (lng) => {
  const short = (lng || "es").slice(0, 2).toLowerCase();
  return CATALOG_LANGS.includes(short) ? short : "es";
};

export default SUGGESTED_TEMPLATES;
